module.exports = __webpack_public_path__ + "static/03-a70a3373c7a248827be3c612efd43b2d.jpg";